export const useSxStyles = () => {
  return {
    sfSection: {
      display: 'inline-block',
      width: '365px',
      verticalAlign: 'top',
      padding: '0 15px 15px 0',
    },
    tabContent: {
      padding: '8px 0px',
      borderBottomRightRadius: '4px',
      backgroundColor: '#ffffff',
    },
  };
};
